module.exports = __webpack_public_path__ + "static/media/alert-icon.5062f239.svg";